module.exports = __webpack_public_path__ + "static/blog-1-2-205d5ca70cb8fb1df8182a881c74c79a.jpg";